//防抖函数
export let deBounce = (fn, delay) => {
    let timer = null;
    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(()=> {
            fn(...args);
        }, delay);
    }
}

//节流函数
export let throttle = (fn, delay) => {
    let flag = true;
    return function (...args) {
        if (!flag) return;
        flag = false;
        setTimeout(() => {
            fn(...args);
            flag = true;
        }, delay);
    }
}

//计算年龄
export function ages(str) {
    var r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
    if (r == null) return false;
    var d = new Date(r[1], r[3] - 1, r[4]);
    if (
      d.getFullYear() == r[1] &&
      d.getMonth() + 1 == r[3] &&
      d.getDate() == r[4]
    ) {
      var Y = new Date().getFullYear();
      return Y - r[1];
    }
}

//随机数
export function RandomString(length) {
    var str = '';
    for ( ; str.length < length; str += Math.random().toString(36).substr(2) );
    return str.substr(0, length);
}

// 判断是否是小程序的 webview 环境
export function isInWechatMPO() {
    if (
        navigator.userAgent.match(/miniprogram/i) ||
        window.wxjs_environment == "miniprogram"
    ) {
        return true;
    } else {
        return false;
    }
}

//生成二维码
import QRCode from 'qrcode';
export function makecode(text){
    var imgurl = '';
    QRCode.toDataURL(text,
        {
            scale:7,
            margin:2,
            errorCorrectionLevel: 'H',
        },
        function (err, url) {
            imgurl = url;
        }
    );

    return imgurl;
}

//播放音频
class Paly{
    constructor() {
        this.audio = document.createElement("audio");
    }
    play(url){
        let device = sessionStorage.device;
        if( device && (device=='android'||device=='windows')){
            this.audio.src = url;
            this.audio.load();
            this.audio.play();
        }
    }
}

export let audioPaly = new Paly();

//获取cookie
export function getCookie(name){
    var prefix = name + "="
    var start = document.cookie.indexOf(prefix)
    if (start == -1) {
        return null;
    }
    var end = document.cookie.indexOf(";", start + prefix.length)
    if (end == -1) {
        end = document.cookie.length;
    }
    var value = document.cookie.substring(start + prefix.length, end)
    return decodeURI(value);
}

//获取二级域名前缀
export function getDomain(){
   let href =  window.location.href;
   if(href.indexOf("localhost")!=-1){
        return 'localhost';
   }else{
        return href.split(".")[0].split("//")[1];
   }
}

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

export function base64ToBlob(base64) {
    const parts = base64.split(';base64,');
    const contentType = parts[0].split(':')[1]; // 获取 MIME 类型
    const raw = window.atob(parts[1]); // 解码 Base64 数据
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
}

export function getBinary(file) {
    return new Promise((resolve, reject) => {
        getBase64(file)
          .then((res) => {
              const arr = res.split(",");
              const mime = arr[0].match(/:(.*?);/)[1];
              const bstr = atob(arr[1]);
              let n = bstr.length;
              const u8arr = new Uint8Array(n);
              while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
              }
              return resolve(new Blob([u8arr], {type: mime}));
          })
          .catch(reject);
    });
}
//计算上上上...周的开始时间和结束时间,week向前推导第几周,time:时间基数
export function getWeek(date,day){
    let time = new Date(new Date(new Date().toLocaleDateString()).getTime()).getTime();
    if(date){   //在时间基数上加减
        time = new Date(new Date(date).toLocaleDateString()).getTime();
    }
    let end;
    if(date){
        if(day>0){
            end = new Date(time-1000*3600*24);
        }else if(day<0){
            end = new Date(time+1000*3600*24);
        }else{
            end = new Date(time);
        }
    }else{
        end = new Date(time);
    }
    let start = new Date(end.getTime()-day*1000*3600*24);
    if(day>0){
        let end_k = `${end.getFullYear()}-${dateZero(end.getMonth()+1)}-01`;
        return {
            start:`${start.getFullYear()}-${dateZero(start.getMonth()+1)}-${dateZero(start.getDate())}`,
            end:`${end.getFullYear()}-${dateZero(end.getMonth()+1)}-${dateZero(end.getDate())}`,
            start1:`${start.getFullYear()}-${dateZero(start.getMonth()+1)}-01`,
            end1:`${end.getFullYear()}-${dateZero(end.getMonth()+1)}-${getDaysInMonth(end_k)}`
        }
    }else{
        let start_k = `${start.getFullYear()}-${dateZero(start.getMonth()+1)}-01`;
        let bool = false;
        let date_0 = new Date();
        let start_0 = `${date_0.getFullYear()}-${dateZero(date_0.getMonth()+1)}-01`;
        if(new Date(start_0).getTime()==new Date(start_k).getTime()){
            bool = true;
        }
        return {
            start:`${end.getFullYear()}-${dateZero(end.getMonth()+1)}-${dateZero(end.getDate())}`,
            end:`${start.getFullYear()}-${dateZero(start.getMonth()+1)}-${dateZero(start.getDate())}`,
            start1:`${end.getFullYear()}-${dateZero(end.getMonth()+1)}-01`,
            end1:`${start.getFullYear()}-${dateZero(start.getMonth()+1)}-${bool?dateZero(date_0.getDate()):getDaysInMonth(start_k)}`,
            bool:bool
        }
    }
    
}

export function dateZero(data){
    return data>9?data:`0${data}`
}

export function getDaysInMonth(v) {
    const now = new Date(v);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const dateString = lastDay.toDateString();
    const day = dateString.split(' ')[2];
    return parseInt(day);
}


import { getPageValidation } from '@/views/report/module/helpers';

function hasValue(val) {
  if (val === undefined || val === null || val === '') return false;
  if (Array.isArray(val) && val.length === 0) return false;
  if (typeof val === 'object' && val !== null && Object.keys(val).length === 0) return false;
  return true;
}

/**
 * 分页导航控制函数（自动跳过无数据的页面）
 * @param {number} page - 当前页码（从1开始）
 * @param {number} next - 翻页方向：-1=上一页，1=下一页
 * @param {object} info - 数据源对象
 * @returns {number} 最终可跳转的有效页码
 */
export function pageFun(page, next, info) {
  const pageConfig = getPageValidation();
  const totalPages = pageConfig.length;
  const isFlowStep19 = Number(info && info.flow_step) === 19;
  const currentPage = page === '3-4' ? (next === 1 ? 4 : 3) : page;
  let target = currentPage + next;

  while (target >= 1 && target <= totalPages) {
    if (isFlowStep19 && ((next === 1 && target === 3) || (next === -1 && target === 4))) {
      return '3-4';
    }

    const keys = pageConfig[target - 1];

    if (keys.length === 0 || keys.every(key => hasValue(info[key]))) {
      return target;
    }

    target += next;
  }
  return page;
}

export function isValidIDCard(idCard){
    // 正则表达式匹配身份证号码格式
    const regex = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/;
    if (!regex.test(idCard)) {
      return false; // 格式不正确
    }
  
    // 身份证号码加权因子
    const weightFactors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    // 身份证号码校验码
    const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
  
    // 计算校验码
    let sum = 0;
    for (let i = 0; i < 17; i++) {
      sum += parseInt(idCard.charAt(i)) * weightFactors[i];
    }
    const checkCodeIndex = sum % 11;
    const checkCode = checkCodes[checkCodeIndex];
  
    // 比较校验码
    return idCard.charAt(17).toUpperCase() === checkCode;
}

export function extractInfoFromIDCard(idCard){
    // 提取生日信息
    const year = idCard.substring(6, 10);
    const month = idCard.substring(10, 12);
    const day = idCard.substring(12, 14);
    const birthday = `${year}-${month}-${day} 00:00`;

    // 提取性别信息
    const genderCode = parseInt(idCard.charAt(16));
    const gender = genderCode % 2 === 0 ? '女' : '男';

    return { birthday, gender };
}

export function isValidPhoneNumber(phoneNumber){
    // 正则表达式匹配手机号码格式
    const regex = /^1[3-9]\d{9}$/;
    return regex.test(phoneNumber);
}

export let ask = [{
    id:1,
    key:'energy'
},{
    id:2,
    key:'fatigue'
},{
    id:3,
    key:'breathe'
},{
    id:4,
    key:'speak'
},{
    id:5,
    key:'unpleasant'
},{
    id:6,
    key:'nervous'
},{
    id:7,
    key:'solitary'
},{
    id:8,
    key:'scare'
},{
    id:9,
    key:'weight'
},{
    id:10,
    key:'eye'
},{
    id:11,
    key:'hand'
},{
    id:12,
    key:'craw'
},{
    id:13,
    key:'cold'
},{
    id:14,
    key:'catchacold'
},{
    id:15,
    key:'runathenose'
},{
    id:16,
    key:'mouth'
},{
    id:17,
    key:'food'
},{
    id:18,
    key:'derma'
},{
    id:19,
    key:'bleeding'
},{
    id:20,
    key:'fingermail'
},{
    id:21,
    key:'oraldry'
},{
    id:22,
    key:'ache'
},{
    id:23,
    key:'face'
},{
    id:24,
    key:'spot'
},{
    id:25,
    key:'sore'
},{
    id:26,
    key:'drinking'
},{
    id:27,
    key:'bittertaste'
},{
    id:28,
    key:'abdomen'
},{
    id:29,
    key:'uncomfortable'
},{
    id:30,
    key:'unwell'
},{
    id:31,
    key:'malaise'
},{
    id:32,
    key:'tongue'
},{
    id:33,
    key:'vein'
}];

export let syndrome = [{
    name:'气虚质',
    key:'qiDeficiencyScore'
},{
    name:'阳虚质',
    key:'yangDeficiencyScore',
},{
    name:'阴虚质',
    key:'yinDeficiencyScore',
},{
    name:'痰湿质',
    key:'phlegmWetScore',
},{
    name:'湿热质',
    key:'dampHeatScore',
},{
    name:'血瘀质',
    key:'bloodStasisScore',
},{
    name:'气郁质',
    key:'qiDepressionScore',
},{
    name:'特禀质',
    key:'specialDiathsisScore',
},{
    name:'平和质',
    key:'gentleQualityScore',
}]

let srz = {
    a0:'面垢油光，口苦口中异味，身重困倦，大便黏滞不畅，小便短黄，男性易阴囊潮湿，女性易带下发黄，舌质偏红，苔黄腻，脉滑数。',
    a1:'面垢油光，口苦口中异味，身重困倦，大便黏滞不畅，小便短黄，男性易带下发黄，舌质偏红，苔黄腻，脉滑数。',
    a2:'面垢油光，口苦口中异味，身重困倦，大便黏滞不畅，小便短黄，女性易阴囊潮湿，舌质偏红，苔黄腻，脉滑数。'
}

let xyz = {
    a0:'宜选用具有调畅气血作用的食物，如生山楂、醋、玫瑰花、桃仁（花）、黑豆、油菜等。少食收涩、寒凉、冰冻之物，如乌梅、柿子、石榴、苦瓜、花生米，以及高脂肪、高胆固醇、油腻食物，如蛋黄、虾、猪头肉、猪脑、奶酪等。还可少量饮用葡萄酒、糯米甜酒，有助于促进血液运行，但高血压和冠心病等患者不宜饮用。女性月经期间慎用活血类食物。',
    a1:'宜选用具有调畅气血作用的食物，如生山楂、醋、玫瑰花、桃仁（花）、黑豆、油菜等。少食收涩、寒凉、冰冻之物，如乌梅、柿子、石榴、苦瓜、花生米，以及高脂肪、高胆固醇、油腻食物，如蛋黄、虾、猪头肉、猪脑、奶酪等。还可少量饮用葡萄酒、糯米甜酒，有助于促进血液运行，但高血压和冠心病等患者不宜饮用。'
}


export function zhFun(zh,data,sex,name){
    if(zh=='湿热质'&&name=='体质特征'){
        if(srz.a0==data){
            if(sex==1||sex==2){
                data = srz[`a${sex}`]
            }
        }
    }
    if(zh=='血瘀质'&&name=='饮食调养'){
        if(xyz.a0==data){
            if(sex==1){
                data = xyz[`a${sex}`]
            }
        }
    }
    return data
}